"use client";

import { ArrowRight } from "@phosphor-icons/react/dist/ssr";

import { Container } from "@/src/components/ui/Container";
import { Button } from "@/src/components/ui/Button";
import { Heading, Text, Highlight } from "@/src/components/ui/Typography";

export function Hero() {
  return (
    <section className="overflow-hidden bg-white">
      <Container>
        <div className="flex items-center pb-20 pt-32">
          <div className="max-w-300 text-center md:text-left">
            <Heading as="h1" size="displayXL" className="max-w-220">
              Transforming <Highlight>SaaS</Highlight> with{" "}
              <Highlight>AI-Powered</Highlight> Product Engineering
            </Heading>

            <Text size="bodyLG" className="mt-8 max-w-190 text-neutral-600">
              Building software where AI is the foundation, not just a feature.
              From product architecture to production systems, we help startup
              founders turn ideas into scalable, AI-native platforms.
            </Text>

            <div className="mt-13.5 flex flex-wrap items-center justify-center gap-6 lg:gap-8 md:justify-start">
              <Button
                href="/book-a-call"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full lg:w-auto"
              >
                Start a Conversation
              </Button>

              <Button
                href="/case-studies"
                variant="link"
              >
                See our work
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
